import { render, staticRenderFns } from "./PurchaseItemForReferenceModal.vue?vue&type=template&id=35fbb9e7&scoped=true&"
import script from "./PurchaseItemForReferenceModal.vue?vue&type=script&lang=js&"
export * from "./PurchaseItemForReferenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbb9e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fbb9e7')) {
      api.createRecord('35fbb9e7', component.options)
    } else {
      api.reload('35fbb9e7', component.options)
    }
    module.hot.accept("./PurchaseItemForReferenceModal.vue?vue&type=template&id=35fbb9e7&scoped=true&", function () {
      api.rerender('35fbb9e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/invoice/components/PurchaseItemForReferenceModal.vue"
export default component.exports